import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, filter, map, mergeMap, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'
import { AnyAction } from 'redux'
import { RootEpic } from '../types'
import {
  getGeneralSettingsRequest,
  getGeneralSettingsSuccess,
  getGeneralSettingsFailure,
  updateGeneralCommissionSettingsRequest,
  updateGeneralCommissionSettingsSuccess,
  updateGeneralCommissionSettingsFailure,
} from '../actions'

export const getGeneralSettingsEpic: RootEpic = (action$, state$, { fetchGeneralSettings }) =>
  action$.pipe(
    filter(isActionOf([getGeneralSettingsRequest])),
    switchMap(() =>
      from(
        fetchGeneralSettings({
          token: state$.value.app.authToken as string,
        }),
      ).pipe(
        map((response) => getGeneralSettingsSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch general settings.')
          return of(getGeneralSettingsFailure(message))
        }),
      ),
    ),
  )

export const updateGeneralCommissionSettingsEpic: RootEpic = (action$, state$, { updateGeneralCommissionSettings }) =>
  action$.pipe(
    filter(isActionOf([updateGeneralCommissionSettingsRequest])),
    switchMap(({ payload }) =>
      from(
        updateGeneralCommissionSettings({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        mergeMap((response) => {
          const actions: Array<AnyAction> = []
          if (response.success) {
            toast.success(response.message)
            actions.push(getGeneralSettingsRequest())
          } else {
            toast.error(response.message)
          }
          actions.push(updateGeneralCommissionSettingsSuccess(response))
          return of(...actions)
        }),
        catchError((error) => {
          let message =
            error?.response?.data?.message || error?.message || 'Failed to update general commission settings.'

          if (Array.isArray(message)) message = message.join(', ')

          toast.error(message)
          return of(updateGeneralCommissionSettingsFailure(message))
        }),
      ),
    ),
  )

export default [getGeneralSettingsEpic, updateGeneralCommissionSettingsEpic]
